<template>
    <main class="page-shell narrow auth-page">
        <section class="brand-panel reset-panel text-center">
            <div class="site-logo justify-content-center mb-4">
                <img src="/assets/sidestream-logo.svg" alt="" aria-hidden="true">
                <span>sidestream.games</span>
            </div>
            <span class="brand-kicker">Account help</span>
            <h1>Reset password</h1>

            <div v-if="tokenValid === null" class="spinner-grow text-primary mt-3" role="status">
                <span class="sr-only"></span>
            </div>
            <div v-else-if="tokenValid === true">
                <div v-if="showSuccess">
                    <b-alert variant="success" show>Password changed.<br><a href="/">Return to the main page.</a></b-alert>
                </div>
                <div v-else>
                    <b-alert variant="danger" v-model="showError" v-html="errorMessage"></b-alert>

                    <form @submit.prevent="reset" class="reset-form">
                        <div class="form-group">
                            <input required v-model="password" type="password" placeholder="new password" class="form-control">
                        </div>
                        <div class="form-group">
                            <input required v-model="passwordConfirm" type="password" placeholder="confirm new password" class="form-control">
                        </div>
                        <button type="submit" class="btn btn-primary btn-lg w-100">Reset password</button>
                    </form>
                </div>
            </div>
            <div v-else>
                <b-alert variant="danger" show>This link is invalid.<br><a href="/">Return to the main page.</a></b-alert>
            </div>
        </section>
    </main>
</template>

<script>
import AuthService from '@/services/auth.service.js'

export default {
    name: 'PasswordReset',
    components: {

    },
    data () {
        return {
            password: null,
            passwordConfirm: null,
            showError: false,
            showSuccess: false,
            errorMessage: "",

            tokenValid: null,
        }
    },
    mounted: function() {
        const token = this.$route.params.token;
        AuthService.verifyPasswordResetToken(token)
            .then(() => {
                this.tokenValid = true;
            })
            .catch(() => {
                this.tokenValid = false;
            });
    },
    methods: {
        reset() {
            if (this.password !== this.passwordConfirm) {
                this.showError = true;
                this.errorMessage = "Passwords do not match!";
                return;
            } else {
                this.showError = false;
            }

            const token = this.$route.params.token;
            AuthService.resetPassword(token, this.password)
            .then(() => {
                this.showError = false;
                this.showSuccess = true;
            })
            .catch(error => {
                this.errorMessage = "<ul class=\"list-group\">"
                error.response.data.error.password.forEach((error) => {
                  this.errorMessage += `<li class="list-group-item list-group-item-danger">${error}</li>`;
                });
                this.errorMessage += "</ul>"
                this.showError = true;
            });

        }
    },
}
</script>

<style scoped>
.reset-panel {
    padding: 1.5rem;
}

.reset-panel h1 {
    margin-bottom: 1.25rem;
    font-size: clamp(2.2rem, 8vw, 3.7rem);
}

.reset-form {
    display: grid;
    gap: 0.75rem;
}
</style>
